/**
 * Parse a jobseeker access GUID from a pasted invite URL or raw code.
 * @param {string} value
 * @returns {string | null}
 */
export function parseAccessGuidFromInput(value) {
  const trimmed = String(value || '').trim();
  if (!trimmed) return null;

  if (!trimmed.includes('/') && !trimmed.includes(':')) {
    return trimmed;
  }

  try {
    const url = new URL(trimmed, typeof window !== 'undefined' ? window.location.origin : 'https://my.rsworks.app');
    const match = url.pathname.match(/\/access\/([^/]+)/i);
    if (match?.[1]) {
      return decodeURIComponent(match[1]);
    }
  } catch {
    /* fall through */
  }

  const pathMatch = trimmed.match(/\/access\/([^/?#]+)/i);
  if (pathMatch?.[1]) {
    return decodeURIComponent(pathMatch[1]);
  }

  return null;
}

/**
 * Parse GUID + query from a pasted invite URL (RSW-377 partner/program params).
 * @param {string} value
 * @returns {{ guid: string, search: string } | null}
 */
export function parseAccessLinkFromInput(value) {
  const trimmed = String(value || '').trim();
  const guid = parseAccessGuidFromInput(trimmed);
  if (!guid) return null;

  let search = '';
  try {
    const url = new URL(trimmed, typeof window !== 'undefined' ? window.location.origin : 'https://my.rsworks.app');
    if (/\/access\//i.test(url.pathname)) {
      search = url.search || '';
    }
  } catch {
    /* fall through */
  }

  if (!search) {
    const q = trimmed.indexOf('?');
    if (q >= 0 && /\/access\//i.test(trimmed)) {
      search = trimmed.slice(q).split('#')[0];
      if (search && !search.startsWith('?')) search = `?${search}`;
    }
  }

  return { guid, search };
}
